import { FC } from 'react';

import { useTheme } from '@mui/material/styles';
import { Backdrop } from '@mui/material';

import './loader.css';

interface Props {
    isLoading: boolean;
    title?: string | JSX.Element;
}

const Loader: FC<Props> = (props) => {
    const { title, isLoading, children } = props;
    const theme = useTheme();

    return (
        <Backdrop
            open={isLoading}
            sx={{
                backgroundColor: theme.palette.mode === 'dark' ? 'rgba(0,0,0,0.6)' : 'rgba(0,0,0,0.3)',
                color: theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.grey[900],
                zIndex: theme.zIndex.drawer + 1
            }}
        >
            <div className="loader-container">
                <div
                    className="loader"
                    ref={(el) =>
                        el?.style.setProperty(
                            '--_g',
                            `no-repeat radial-gradient(circle closest-side, ${
                                theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.grey[900]
                            } 90%, #0000)`
                        )
                    }
                />
                <span>{title ?? children}</span>
            </div>
        </Backdrop>
    );
};

export default Loader;
